"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { useMemo, useState } from "react";
import { WorldCupArticleCard } from "@/components/site/world-cup/world-cup-article-card";
import type { WorldCupArticle } from "@/lib/world-cup-data";

const PAGE_SIZE = 4;

export function WorldCupFeaturedCarousel({ articles }: { articles: WorldCupArticle[] }) {
  const [page, setPage] = useState(0);
  const pageCount = Math.max(1, Math.ceil(articles.length / PAGE_SIZE));
  const visible = useMemo(() => articles.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE), [articles, page]);

  return (
    <section className="mt-14">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3 border-b border-[#D8C7AE] pb-3">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-[#A4243B]">Szerkesztőségi válogatás</p>
          <h2 className="mt-1 font-display text-3xl font-bold leading-none text-[#111111] md:text-4xl">Kiemelt történetek</h2>
        </div>
        {articles.length ? (
          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="Előző válogatás"
              className="grid h-9 w-9 place-items-center rounded-full border border-[#D8C7AE] bg-white text-[#273E47] disabled:opacity-40"
              onClick={() => setPage((value) => Math.max(0, value - 1))}
              disabled={page === 0}
            >
              <ChevronLeft size={17} />
            </button>
            <span className="text-xs font-black text-[#8B8175]">
              {page + 1}/{pageCount}
            </span>
            <button
              type="button"
              aria-label="Következő válogatás"
              className="grid h-9 w-9 place-items-center rounded-full border border-[#D8C7AE] bg-white text-[#273E47] disabled:opacity-40"
              onClick={() => setPage((value) => Math.min(pageCount - 1, value + 1))}
              disabled={page >= pageCount - 1}
            >
              <ChevronRight size={17} />
            </button>
          </div>
        ) : null}
      </div>
      {articles.length ? (
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {visible.map((article) => (
            <WorldCupArticleCard key={article.id} article={article} compact />
          ))}
        </div>
      ) : (
        <div className="rounded-md border border-dashed border-[#D8C7AE] bg-[#F7F5EF] p-6 text-sm font-semibold text-[#6B6B6B]">
          Még nincs világbajnoksági válogatás.
        </div>
      )}
    </section>
  );
}
